<template>
  <hm-content title="">
    <el-row :gutter="10">
      <el-col
        :xs="12"
        :sm="12"
        :md="8"
        :lg="8"
        :xl="8"
        class="mb20 pointer"
        v-for="(v, i) in list"
        :key="i"
        ><div class="plan-box" @click="addPlan(v)">
          <div class="plan-title">
            {{ v.title }}
          </div>
          <div class="plan-content">
            <div style="height:100px;">
              {{ v.content }}
            </div>

            <div class="flex flex-center">
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span style="lineHeight: 30px; color:#E50065">新增运营计划</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [
        {
          title: "新客转化",
          content: "90天内新注册会员，但是没有产生消费的会员群体，每日更新!",
          type: "new_member"
        },
        {
          title: "阶段营销",
          content:
            "母婴行业特有群体，根据宝宝的生理轴信息变更，进入新的生理轴阶段的会员群体；比如宝宝从3个月成长到3个月1天，进入3-6个月的阶段，每日更新！",
          type: "stage_sale"
        },
        {
          title: "复购推荐",
          content:
            "根据商品的复购规则，计算会员上次购买该商品后的消耗周期，到达周期时间仍无购买记录的会员群体；比如一听奶粉消耗7天，在第8天会进入群体，每日更新!",
          type: "repurchase_recommendation"
        },
        {
          title: "流失预警",
          content: "距离最后一次消费，已经有90天的会员群体，每日更新！",
          type: "loss_warning"
        },
        {
          title: "宝宝出生",
          content:
            "根据预产期的信息，计算为宝宝出生日期，家优新生儿出生的会员群体，每日更新！",
          type: "baby_born"
        },
        {
          title: "会员生日",
          content: "根据会员注册生日信息，当日为生日的会员群体，每日更新!",
          type: "member_birthday"
        },
        {
          title: "宝宝满月",
          content: "根据家庭档案信息，宝宝出生30为满月的会员群体，每日更新！",
          type: "baby_full_month"
        },
        {
          title: "出月子",
          content:
            "根据预产期信息，计算宝宝出生后第42天，应该出月子的会员群体，每日更新！",
          type: "out_month"
        },
        {
          title: "宝宝百天",
          content: "根据家庭档案，宝宝出生100天的会员群体，每日更新！",
          type: "baby_hundred_days"
        },
        {
          title: "一周岁",
          content: "根据家庭档案，宝宝一周岁的会员群体，每日更新！",
          type: "baby_one_year"
        },
        {
          title: "会员累计消费返利",
          content: "根据会员累计消费金额来确认返利！",
          type: "plus_card"
        },
        {
          title: "宝宝生日",
          content: "根据家庭档案信息,当日为宝宝生日的会员群体，每日更新!",
          type: "baby_birthday"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    addPlan(row) {
      this.$router.push({
        name: "AddOperationPlan",
        query: {
          renqun: row.type === "plus_card" ? "PLUS会员" : row.title,
          type: row.type
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.plan-box {
  box-shadow: 0px 0px 18px 0px rgba(230, 230, 230, 1);
  border-radius: 6px;
  .plan-title {
    background: #e50065;
    height: 46px;
    line-height: 46px;
    color: #fff;
    border-radius: 4px;
    padding-left: 10px;
  }
  .plan-content {
    // height: 162px;
    padding: 20px;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin-right: 10px;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
</style>
